import ReactGA from "react-ga4";

export const informCustomEvent = (eventName, data = {}) => {
    console.log(eventName)
    ReactGA.event(eventName, data)
}